export default __webpack_public_path__ + "static/newsletter-img-c6b7825941832fdfc409129479d12cc2.png";